import { render, staticRenderFns } from "./PremiumModalDefaultContent.vue?vue&type=template&id=c817f6ac&scoped=true&"
import script from "./PremiumModalDefaultContent.vue?vue&type=script&lang=js&"
export * from "./PremiumModalDefaultContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c817f6ac",
  null
  
)

export default component.exports